<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>

			<!-- <Button type="primary"  style="margin-right: 5px" @click="equipmentUpdate()" >修改负责人</Button>
			<Button type="primary"  style="margin-right: 5px" @click="updatePhone()" v-show="macLeaveFactory.macKind=='KFJ'" >修改体验者账号</Button> -->
		</div>
		<div class="mac">
			<!-- <div class="mac-1">设备编号：{{macLeaveFactory.macCode}}</div>
			<div class="mac-1">设备类型：{{macLeaveFactory.macDetailsName}}</div> -->
			
			<div class="mac-1">
				<div class="mac-1-1" v-if="table!=1">
					<a @click="xs(1)" style="text-decoration:underline">返回上一页</a>
				</div>
				<div class="mac-1-1" v-if="data7.length>0">
					<a @click="xs(2)">查看故障货道<Badge :count="data7.length"></Badge></a>
				</div>
				<div class="mac-1-1" v-if="data8.length>0">
					<a @click="xs(3)">查看缺货货道<Badge :count="data8.length"></Badge></a>
				</div>
				<!-- <Select v-model="query.commIds"  multiple filterable placeholder="请选择商品" @on-change="ajaxPage">
					<Option v-for="item in comms" :key="item.id" :value="item.id">{{item.name}}</Option>
				</Select> -->
				<div  style="width: 200px;display: flex;align-items: center;">
					<div style="width: 50px;">状态：</div>
					<Select v-model="query.zt"  style="width:150px" clearable filterable='true' @on-change="onchangeSousuo">
					        <Option v-for="item in zts" :value="item.id" :key="item.id">{{ item.name }}</Option>
					</Select>
				</div> 
				<Button class="excel" @click="download" type="primary">导出Excel</Button>
			</div>
			<Input style="width: 500px;" search enter-button="搜索" placeholder="请输入货道编号/商品名称" v-model="query.like"
				@on-search="onclick" />
		</div>

		<div v-show="table==1">
			<Table border :columns="columns12" :data="data6" :loading="loading" :height="h1">
				<template slot-scope="{ row, index }" slot="action">
					<!-- v-show="row.isOver>=0" -->
					<Button type="primary" size="small" style="margin-right: 5px" @click="update(row.id)"
						v-show="row.state=='zc' && (row.shipmentId==null || row.shipmentId=='')">修改</Button>
					<!-- <Button type="primary" size="small" style="margin-right: 5px" @click="update(row.id)">修改</Button> -->
					<Button type="error" size="small"
						v-show="!(row.shipmentId==null || row.shipmentId=='')">已并道</Button>
				</template>
			</Table>

			<div class="my-page">
				<page :total="total" v-if="pageShow" @updatePage="updatePage" @updateSize="updateSize"></page>
			</div>

		</div>
		<div v-show="table==2">
			<Table border :columns="columns12" :data="data7" :loading="loading" :height="h1">
				<template slot-scope="{ row, index }" slot="action">
					<!-- v-show="row.isOver>=0" -->
					<Button type="primary" size="small" style="margin-right: 5px" @click="update(row.id)"
						v-show="row.state=='zc'">修改</Button>
				</template>
			</Table>

			<div class="my-page">
				<page2 :total="total" @updatePage="updatePage" @updateSize="updateSize"></page2>
			</div>
		</div>
		<div v-show="table==3">
			<Table border :columns="columns12" :data="data8" :loading="loading" :height="h1">
				<template slot-scope="{ row, index }" slot="action">
					<!-- v-show="row.isOver>=0" -->
					<Button type="primary" size="small" style="margin-right: 5px" @click="update(row.id)"
						v-show="row.state=='zc'">修改</Button>
				</template>
			</Table>

			<div class="my-page">
				<page3 :total="total" @updatePage="updatePage" @updateSize="updateSize"></page3>
			</div>
		</div>



	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	import page2 from '@/components/comm/page.vue'
	import page3 from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				macKind:'',
				zts:[
					{id:1,name:'正常'},
					{id:2,name:'警报'},
				],
				h1: '',
				pageSize: 10,
				table: 1,
				comms: [],
				macLeaveFactory: {},
				total: 100,
				total1: 100,
				total2: 100,
				total3: 100,
				pageShow: true,
				query: {
					page: '0',
					size: 10,
					macId: '',
					like: '',
					commIds: [],
					zt:''
				},
				query2: {
					page: '0',
					size: 10,
					macId: '',
					like: '',
					commIds: []
				},
				query3: {
					page: '0',
					size: 10,
					macId: '',
					like: '',
					commIds: []
				},
				columns12: [
					/* {
						type: 'selection',
						width: 60,
						align: 'center'
					}, */
					{
						title: 'id',
						width: 100,
						key: 'id',
						fixed: 'left',
					},
					{
						title: '图片',
						key: 'img',
						width: 136,
						render: (h, params) => {
							if (params.row.operComm.img != null) {
								return h('div', [
									h('img', {
										style: {
											width: "100px",
											height: '100px',
											verticalAlign: "middle"
										},
										attrs: {
											src: params.row.operComm.img
										}
									}, )
								]);
							} else {
								return h('div', "");
							}

						}
					},

					// {
					// 	title: '订单编号',
					// 	key: 'operOrderId'
					// },
					// {
					// 	title: '设备所属加盟商',
					// 	key: 'alliance',
					// 	render: (h, params) => {
					// 			return h("div",params.row.alliance.companyName)
					// 	}
					// },
					{
						title: '设备编号',
						width: 100,
						key: 'macId',
						render: (h, params) => {
							return h("div", params.row.macLeaveFactory.id)
						}
					},
					{
						title: '货道编号',
						width: 100,
						key: 'number'
					},
					{
						title: '商品名称',
						key: 'operComm',
						width: 200,
						render: (h, params) => {
							return h("div", params.row.operComm.name)
						}
					},
					{
						title: '有效期(天)',
						width: 100,
						key: 'expirationTimeNumber',
						render: (h, params) => {
							return h("div", params.row.expirationTimeNumber == null ? '' : params.row
								.expirationTimeNumber + "天")
						}
					},
					{
						title: '报警阀值(天)',
						width: 120,
						key: 'remindTimeNumber',
						render: (h, params) => {
							return h("div", params.row.remindTimeNumber == null ? '' : params.row
								.remindTimeNumber + '天')
						}
					}, {
						title: '临期状态',
						key: 'lqjb',
						width: 100,
						align: 'center',
						render: (h, params) => {
							if (params.row.lqjb == 1) {
								return h("div", {
									style: {
										color: '#67C23A'
									}
								}, "正常")
							} else {
								return h("div", {
									style: {
										color: 'red'
									}
								}, "警报")
							}
						}
					},
					{
						title: '生产厂商',
						key: 'manuString',
						width: 200,
						render: (h, params) => {
							return h("div", params.row.operComm.manuString)
						}
					},
					{
						title: '规格',
						key: 'specification',
						width: 100,
						render: (h, params) => {
							return h("div", params.row.operComm.specification)
						}
					},
					{
						title: '售价(元)',
						key: 'sellPrice',
						width: 100,
						render: (h, params) => {
							return h("div", params.row.sellPrice / 100)
						}
					},
					{
						title: '最大数量',
						width: 100,
						key: 'maxNumber'
					},
					{
						title: '当前数量',
						width: 100,
						key: 'currentMayNumber',
						render: (h, params) => {
							if (Number(params.row.currentMayNumber) < Number(params.row.minNumber) && params.row
								.operComm.name != null && params.row.operComm.name != "") {
								return h("div", {
									style: {
										color: 'red'
									}
								}, params.row.currentMayNumber + params.row.currentNoMayNumber)
							} else {
								return h("div", {
									style: {
										color: 'green'
									}
								}, params.row.currentMayNumber + params.row.currentNoMayNumber)
							}
						}
					},
					{
						title: '待出货数量',
						width: 100,
						key: 'currentNoMayNumber',

					},
					{
						title: '可补货数量',
						width: 100,
						key: 'currentNoMayNumbers',
						render: (h, params) => {
							return h("div", Number(params.row.maxNumber) - Number(params.row.currentMayNumber) -
								Number(params.row.currentNoMayNumber))
						}
					},
					{
						title: '库存报警数',
						width: 100,
						key: 'minNumber'
					},
					{
						title: '状态',
						width: 100,
						key: 'state',
						render: (h, params) => {
							if (params.row.state == "zc") {
								if (Number(params.row.currentMayNumber) < Number(params.row.minNumber) && params
									.row.operComm.name != null && params.row.operComm.name != "") {
									return h("div", {
										style: {
											color: 'red'
										}
									}, "缺货")
								} else {
									return h("div", {
										style: {
											color: 'green'
										}
									}, "正常")
								}

							} else {
								return h("div", {
									style: {
										color: 'red'
									}
								}, "故障")
							}
						}
					},
					// {
					// 	title: '管理人员',
					// 	width: 100,
					// 	key: 'operEmpName'
					// },
					// {
					// 	title: '开始时间',
					// 	key: 'beginDateTime'
					// },
					// {
					// 	title: '结束时间',
					// 	key: 'overDateTime'
					// },
					// {
					// 	title: '到期天数',
					// 	key: 'isOver',
					// 	render: (h, params) => {
					// 		if(params.row.operator.companyName!=null){
					// 			if(params.row.isOver>=0){
					// 				if(params.row.isOver<10){
					// 					return h("div",{style:{color:'#D5D52B'}},params.row.isOver+"天")
					// 				}else{

					// 					return h("div",params.row.isOver+"天")
					// 				}
					// 			}else {
					// 				return h("div",{style:{color:'red'}},"已到期")
					// 			}
					// 		}else{
					// 			return h("div","")
					// 		}

					// 	}

					// },
					{
						title: '操作',
						slot: 'action',
						width: 100,
						fixed: 'right',
						align: 'center'
					}
				],
				data6: [

				],
				data7: [

				],

				data8: [

				],
				loading: false,

			}
		},
		methods: {
			onchangeSousuo(){
				this.onclick()
			},
			download() {
				var alldata = []
				this.loading = true
				let _this = this
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/mac/leave/factory/aisle/page/oper',
					data: {
						"commIds": [],
						"like": "",
						"macId": _this.query.macId,
						"page": "0",
						"size": 1000
					},
					_this: _this,
					success: function(data) {
						alldata = data.aisles.content
						_this.loading = false
						require.ensure([], () => {
							const {
								export_json_to_excel
							} = require('../../../../../excel/Export2Excel.js')
							// const tHeader = ['货道编号','商品名称','生产厂商','规格','售价','当前数量']
							// const filterVal = ['number','operCommname','operCommmanuString','operCommspecification','sellPrice','currentMayNumber']
							const tHeader = ['设备编号', '货道编号', '商品名称', '生产厂商', '规格', '售价(元)', '最大库存量',
								'当前数量', '待出货数量', '可补货数量', '库存报警数'
							]
							const filterVal = ['id', 'number', 'operCommname', 'manuString',
								'specification', 'sellPrice', 'maxNumber', 'currentMayNumber',
								'currentNoMayNumber', 'currentNoMayNumbers', 'minNumber'
							]
							let listfix = []
							alldata.forEach((item, index) => {
								if (item.operComm.name) {
									/*let obj={
									  'number':item.number,
									  'operCommname':item.operComm.name,
									  'operCommmanuString':item.operComm.manuString,
									  'operCommspecification':item.operComm.specification,
									  'sellPrice':item.sellPrice/100,
									  'currentMayNumber':item.currentMayNumber
									}*/
									let obj = {
										'id': item.macLeaveFactory.id,
										'number': item.number,
										'operCommname': item.operComm.name,
										'manuString': item.operComm.manuString,
										'specification': item.operComm.specification,
										'sellPrice': item.sellPrice / 100,
										'maxNumber': item.maxNumber,
										'currentMayNumber': item.currentMayNumber + item
											.currentNoMayNumber,
										'currentNoMayNumber': item.currentNoMayNumber,
										'currentNoMayNumbers': item.maxNumber - item
											.currentMayNumber - item.currentNoMayNumber,
										'minNumber': item.minNumber
									}
									listfix.push(obj)
								}
							})
							const list = [...listfix]
							const data = _this.formatJson(filterVal, list)
							export_json_to_excel(tHeader, data, _this.$route.query.id + '设备货道商品信息表')
						})
					}
				})
			},
			formatJson(filterVal, jsonData) { //这里必须写
				return jsonData.map(v => filterVal.map(j => v[j]))
			},

			xs(a) {
				this.table = a
				if (a == 1) {
					this.total = this.total1
				} else if (a == 2) {
					this.total = this.total2
				} else {
					this.total = this.total3
				}
			},
			onclick() {
				this.query.page = 0
				this.pageShow = false
				this.$nextTick(() => (this.pageShow = true))
				this.ajaxPage()
			},
			queryComm() {
				let _this = this
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/oper/operComMerchandise/page',
					data: {
						page: 0,
						size: 1000
					},
					_this: _this,
					success: function(data) {
						_this.comms = data.page.content

					}
					//假设后台需要的是表单数据这里你就可以更改
				})
			},
			queryById() {
				let _this = this
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/fac/mac/leave/factory/findById',
					data: {
						id: _this.query.macId
					},
					_this: _this,
					success: function(data) {
						_this.macLeaveFactory = data.macLeaveFactory
					}
					//假设后台需要的是表单数据这里你就可以更改
				})
			},
			ret() { //返回上一页
				this.$router.go(-1)
			},
			equipmentUpdate() {
				this.$router.push({
					name: 'oper/mac/update',
					query: {
						operMacId: this.query.macId
					}
				})
			},
			updatePhone() {
				this.$router.push({
					name: 'oper/mac/update/phone',
					query: {
						operMacId: this.query.macId
					}
				})
			},
			update(id) { //修改
				this.$router.push({
					name: 'oper/mac/aisle/update',
					query: {
						id: id,
						macId: this.query.macId,
						macKind:this.macKind
					}
				})
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				if (this.table == 1) {
					this.query.page = page - 1
					this.ajaxPage()
				} else if (this.table == 2) {
					this.query2.page = page - 1
					this.ajaxPage2()
				} else {
					this.query3.page = page - 1
					this.ajaxPage3()
				}
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				if (this.table == 1) {
					this.query.size = size
					this.ajaxPage()
				} else if (this.table == 2) {
					this.query2.size = size
					this.ajaxPage2()
				} else {
					this.query3.size = size
					this.ajaxPage3()
				}

			},

			ajaxPage() {
				this.loading = true
				let _this = this
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/mac/leave/factory/aisle/page/oper',
					data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.aisles.totalElements
						_this.total1 = data.aisles.totalElements
						_this.data6 = data.aisles.content
						_this.loading = false
					}
					//假设后台需要的是表单数据这里你就可以更改
				})

			},
			ajaxPageGZ() {
				let _this = this
				http.http({
					//这里是你自己的请求方式、url和data参数
				 method: 'post',
					url: http.url + '/mac/leave/factory/aisle/page/oper/gz',
					data: _this.query2,
					_this: _this,
					success: function(data) {
						_this.total2 = data.aisles.totalElements
						_this.data7 = data.aisles.content
					}
					//假设后台需要的是表单数据这里你就可以更改
				})

			},
			ajaxPageQH() {
				let _this = this
				http.http({
					//这里是你自己的请求方式、url和data参数
				 method: 'post',
					url: http.url + '/mac/leave/factory/aisle/page/oper/qh',
					data: _this.query3,
					_this: _this,
					success: function(data) {
						_this.total3 = data.aisles.totalElements
						_this.data8 = data.aisles.content
					}
					//假设后台需要的是表单数据这里你就可以更改
				})

			},

		},
		components: {
			page,
			page2,
			page3
		},
		created() {
			this.macKind = this.$route.query.macKind
			this.query.macId = this.$route.query.id
			this.query2.macId = this.$route.query.id
			this.query3.macId = this.$route.query.id
			this.ajaxPage();
			this.queryById()
			this.ajaxPageQH()
			this.ajaxPageGZ()
			//this.queryComm()
			var hegiht = document.documentElement.clientHeight - 365

			this.h1 = hegiht
		},
		//监听屏幕变化
		mounted() {
			const that = this
			window.onresize = () => {
				return (() => {
					var hegiht = document.documentElement.clientHeight - 365
					this.minHeight = hegiht
					this.h1 = hegiht
				})()
			}
		},
		activated() {
			// if(this.table==1){
			// 	this.ajaxPage()
			// }else if(this.table==2){
			// 	this.ajaxPageGZ()
			// }else{
			// 	this.ajaxPageQH()
			// }
			this.ajaxPage()
			this.ajaxPageQH()
			this.ajaxPageGZ()
		}

	}
</script>
<style scoped="scoped" lang="less">
	.excel {
		border: none;
		margin-left: 10px;
		margin-bottom: 5px;
		padding: 0 5px 0 5px;
		background: #57a3f3;
		border-radius: 5px;
		color: #fff;
		cursor: pointer;
	}

	.list-btn {
		margin-bottom: 20px;
	}

	.mac {
		display: flex;
		justify-content: space-between;

		.mac-1 {
			display: flex;

			.mac-1-1 {
				margin-left: 10px;
			}
		}
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/oper/mac/aisle/list.vue